import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { NumericFormat } from 'react-number-format';
import { currentTenant, financialyearstart, financialyearend, thousandsdisplay, transactionFrom } from '../../Common/Credentials';
import Header from '../../Component/Header';
import Menu from '../../Component/Menu';
import { spin } from '../../Common/NewLoader';
import Footer from '../../Component/Footer';
import MUIDataTable from "mui-datatables";
import { TextField, createTheme, Autocomplete, Grid, ThemeProvider } from "@mui/material";
import { Form, Formik } from "formik";
import { FormikTextField } from '../../CommonComponents/FormField.js';
import moment from "moment";
import dayjs from "dayjs";
import NewJournalService from "../NewJournalService";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

export default function LedgersViewNew(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [banks, setBanks] = useState([]);
  const [ledger, setLedgers] = useState([]);
  const [selectedLed, setselectedLed] = useState([]);
  const [openingamt, setopeningamt] = useState(0);
  const [SDdate, setSDdate] = useState(false);
  const [fsd, setFsd] = useState(null);
  const [fed, setFed] = useState(null);
  const [selid, setSelid] = useState(null);
  const [currentamt, setcurrentamt] = useState(0);
  const [debtotal, setdebtotal] = useState(0);
  const [cretotal, setcretotal] = useState(0);
  const [ledgercode, setledgercode] = useState("");
  const [selectedledger, setSelectedledger] = useState('');

  const formatStartDate = (d) => {
    if (!d) {
      if (financialyearstart) return `${moment(financialyearstart).format("YYYY-MM-DD")} 00:00:01.000`;
      if (transactionFrom) return `${moment(transactionFrom).format("YYYY-MM-DD")} 00:00:01.000`;
      return `${moment().startOf('year').format("YYYY-MM-DD")} 00:00:01.000`;
    }
    return `${moment(d).format("YYYY-MM-DD")} 00:00:01.000`;
  };

  const formatEndDate = (d) => {
    if (!d) {
      if (financialyearend) return `${moment(financialyearend).format("YYYY-MM-DD")} 23:59:59.999`;
      return `${moment().endOf('year').format("YYYY-MM-DD")} 23:59:59.999`;
    }
    return `${moment(d).format("YYYY-MM-DD")} 23:59:59.999`;
  };

  const updateSummaries = (dataList) => {
    if (!dataList || dataList.length === 0) {
      setopeningamt(0);
      setdebtotal(0);
      setcretotal(0);
      setcurrentamt(0);
      return;
    }

    let debTotal = 0;
    let creTotal = 0;

    dataList.forEach((item) => {
      const amt = Number(item.jvamount) || 0;
      if (item.entryType === "DEBIT") {
        debTotal += amt;
      } else if (item.entryType === "CREDIT") {
        creTotal += amt;
      }
    });

    setdebtotal(debTotal.toFixed(2));
    setcretotal(creTotal.toFixed(2));

    const itemWithClosing = dataList.find(
      (e) => e.closingbalance !== undefined && e.closingbalance !== null
    );
    if (itemWithClosing) {
      setcurrentamt(Number(itemWithClosing.closingbalance).toFixed(2));
    } else if (dataList.length > 0) {
      setcurrentamt(Number(dataList[0].amount || 0).toFixed(2));
    }

    const openingItem = dataList.find((e) => e.isopening === 1);
    if (openingItem) {
      setopeningamt(Number(openingItem.amount || 0).toFixed(2));
    } else if (dataList.length > 0) {
      const oldestItem = dataList[dataList.length - 1];
      setopeningamt(Number(oldestItem.currentamt || 0).toFixed(2));
    }
  };

  const fetchLedgerData = (targetLedgerId, fromD, toD) => {
    const idToUse = targetLedgerId || selid;
    const fromToUse = fromD !== undefined ? fromD : fsd;
    const toToUse = toD !== undefined ? toD : fed;

    if (!idToUse) return;

    setLoading(true);
    const reqData = {
      tenantId: currentTenant,
      fromDate: fromToUse,
      toDate: toToUse,
      ledid: idToUse
    };

    NewJournalService.getPartyLedgersView(reqData)
      .then((response) => {
        const rows = response.data || [];
        setselectedLed(rows);
        updateSummaries(rows);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching party ledger view:", err);
        setselectedLed([]);
        updateSummaries([]);
        setLoading(false);
      });
  };

  const theme = createTheme({
    overrides: {
      MuiTableCell: {
        head: {
          backgroundColor: "#e9ecef !important",
          border: [[1, "solid", "#ece6e6"]],
        },
        body: {
          border: [[1, "solid", "#ece6e6"]],
        },
      },
    },
  });

  const parseNavigationParams = () => {
    const searchParams = new URLSearchParams(location.search);
    const queryId = searchParams.get('id') || searchParams.get('ledgerid');
    const queryName = searchParams.get('name') || searchParams.get('ledgername');
    const queryFrom =
      searchParams.get('financialyearstart') ||
      searchParams.get('fromDate') ||
      searchParams.get('from') ||
      searchParams.get('start');
    const queryTo =
      searchParams.get('financialyearend') ||
      searchParams.get('toDate') ||
      searchParams.get('to') ||
      searchParams.get('end');

    let stateId = null;
    let stateName = null;
    let stateFrom = null;
    let stateTo = null;

    if (typeof location.state === 'string') {
      stateName = location.state;
    } else if (location.state && typeof location.state === 'object') {
      stateId = location.state.id || location.state.ledgerid;
      stateName = location.state.name || location.state.ledgername;
      stateFrom =
        location.state.financialyearstart ||
        location.state.fromDate ||
        location.state.from;
      stateTo =
        location.state.financialyearend ||
        location.state.toDate ||
        location.state.to;
    }

    const targetId = stateId || queryId;
    const targetName = stateName || queryName;
    const incomingFrom = stateFrom || queryFrom;
    const incomingTo = stateTo || queryTo;

    return { targetId, targetName, incomingFrom, incomingTo };
  };

  useEffect(() => {
    NewJournalService.getpartyled(currentTenant).then((response) => {
      const ledList = response.data || [];
      setLedgers(ledList);

      const { targetId, targetName, incomingFrom, incomingTo } = parseNavigationParams();
      const cleanTargetName = targetName ? targetName.replace(/\s*\[.*?\]$/, '').trim().toLowerCase() : null;

      if (targetId && !targetName) {
        const match = ledList.find((l) => l.id === targetId);
        if (match && match.name) {
          setSelectedledger(match.name.trim());
        }
      } else if (!targetId && cleanTargetName) {
        const match = ledList.find(
          (l) => l.name && l.name.trim().toLowerCase() === cleanTargetName
        );
        if (match) {
          setSelid(match.id);
          setSelectedledger(match.name.trim());
          const fromFormatted = formatStartDate(incomingFrom);
          const toFormatted = formatEndDate(incomingTo);
          fetchLedgerData(match.id, fromFormatted, toFormatted);
        }
      }
    });
  }, []);

  useEffect(() => {
    const { targetId, targetName, incomingFrom, incomingTo } = parseNavigationParams();

    const fromFormatted = formatStartDate(incomingFrom);
    const toFormatted = formatEndDate(incomingTo);

    setFsd(fromFormatted);
    setFed(toFormatted);

    if (targetName) {
      const cleanName = targetName.replace(/\s*\[.*?\]$/, '').trim();
      setSelectedledger(cleanName);
    }

    if (targetId) {
      setSelid(targetId);
      fetchLedgerData(targetId, fromFormatted, toFormatted);
    }
  }, [location]);

  const submitRecord = (value) => {
    let directaddedstock;
    if (value !== undefined) {
      // directaddedstock=dirstock.filter(e=>e.id===value.rowData[0])
    }
    navigate(`/dirstockentry`, { state: { directaddedstock } });
  };

  function handleSDDate() {
    setSDdate(!SDdate);
    if (!SDdate) {
      setFed(null);
      setFsd(null);
    }
  }

  function handleFsdDateChange(date) {
    if (date) {
      const d = date.$d || date;
      setFsd(`${moment(d).format("YYYY-MM-DD")} 00:00:01.000`);
    } else {
      setFsd(null);
      setSDdate(false);
    }
  }

  function handleFsdDateChange1(date) {
    if (date) {
      const d = date.$d || date;
      setFed(`${moment(d).format("YYYY-MM-DD")} 23:59:59.999`);
    } else {
      setFed(null);
      setSDdate(false);
    }
  }

  const Bankcolumns = [
    {
      name: "behav",
      label: "EntryType",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "createdAt",
      label: "Date",
      options: {
        filter: false,
        sort: true,
        sortOrder: 'asc',
        customBodyRender: (tableMeta) => {
          return moment(tableMeta).format("DD-MM-YYYY hh:mm");
        },
      },
    },    
    {name: "orderid",label: "Type",options: {filter: false,sort: true,}},
   // {name: "jvinsertiontype",label: "Trans",options: {filter: false,sort: true,}},
    {name:"debitname",label:"Dr Ledger",options: {filter: true,sort: true,
    //  customBodyRender: (tableMeta, values) => {
    //    // console.log(values.rowData.find((e) => e))
    //     return values.rowData.find((e) => e) !== 1?tableMeta:"-NA-"

    //      }
      }},
      {name:"creditname",label:"Cr Ledger",options: {filter: true,sort: true,
        // customBodyRender: (tableMeta, values) => {
        //   // console.log(values.rowData.find((e) => e))
        //    return values.rowData.find((e) => e) === 1?tableMeta:"-NA-"
   
        //     }
         }},

    {
      name: "currentamt",
      label: "Previous/Opening Balance",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (tableMeta) => {
          return (
            <NumericFormat
              className="pr-3"
              displayType={"text"}
              value={tableMeta}
              decimalScale={2}
              fixedDecimalScale={true}
              disabled={true}
              thousandSeparator={true}
              thousandsGroupStyle={thousandsdisplay}
            ></NumericFormat>
          );
        },
        setCellProps: (value) => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "jvamount",
      label: "Debit",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (tableMeta, values) => {
          //  console.log(values.rowData[10])
          return (
            <>
              {values.rowData[12] ==="DEBIT" ?//("+"):("-")}
              <NumericFormat
                className="pr-3"
                displayType={"text"}
                value={tableMeta}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled={true}
                thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay}
              ></NumericFormat> :0}
            </>
          );
        },
        setCellProps: (value) => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "jvamount",
      label: "Credit",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (tableMeta, values) => {
          //console.log(values.rowData.find(e=>e))
          return (
            <>
              {values.rowData[12]=== "CREDIT" ?
              <NumericFormat
                className="pr-3"
                displayType={"text"}
                value={tableMeta}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled={true}
                thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay}
              ></NumericFormat> : 0}
            </>
          );
        },
        setCellProps: (value) => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "genadvanceadded",
      label: "Gen Adv",
      options: {
        filter: false,
        sort: true,
        display: false,
        customBodyRender: (tableMeta, values) => {
         // console.log(values.rowData)
          return (
            <>
              {values.rowData[12]=== "CREDIT" && values.rowData[13]=== "TH3" ?
              <NumericFormat
                className="pr-3"
                displayType={"text"}
                value={tableMeta}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled={true}
                thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay}
              ></NumericFormat> :""}
              {values.rowData[12]=== "DEBIT" && values.rowData[13]=== "TH4"?  
              <NumericFormat
              className="pr-3"
              displayType={"text"}
              value={tableMeta}
              decimalScale={2}
              fixedDecimalScale={true}
              disabled={true}
              thousandSeparator={true}
              thousandsGroupStyle={thousandsdisplay}
            ></NumericFormat>:""}
              
            </>
          );
        },
        setCellProps: (value) => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "jvamount",
      label: "Gen Adv Adj",
      options: {
        filter: false,
        sort: true,
        display: false,
        customBodyRender: (tableMeta, values) => {
          //console.log(values.rowData)
          return (
            <>
              {values.rowData[12]=== "CREDIT"  && values.rowData[13]=== "TH3" ?
              <NumericFormat
                className="pr-3"
                displayType={"text"}
                value={tableMeta}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled={true}
                thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay}
              ></NumericFormat> : ""}
               {values.rowData[12]=== "DEBIT"  && values.rowData[13]=== "TH4" ?
              <NumericFormat
                className="pr-3"
                displayType={"text"}
                value={tableMeta}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled={true}
                thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay}
              ></NumericFormat> : ""}
            </>
          );
        },
        setCellProps: (value) => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "amount",
      label: "Current/Closing Balance",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (tableMeta) => {
          return (
            <NumericFormat
              className="pr-3"
              displayType={"text"}
              value={tableMeta}
              decimalScale={2}
              fixedDecimalScale={true}
              disabled={true}
              thousandSeparator={true}
              thousandsGroupStyle={thousandsdisplay}
            ></NumericFormat>
          );
        },
        setCellProps: (value) => ({ style: { textAlign: "right" } }),
        //   customHeadRender: (columnMeta,) => (
        //     <div style={{style: { textAlign:'right'}}}>
        //         {columnMeta.name}
        //     </div>
        // )
      },
    },
   
   

    {
      name: "id",
      label: "Transaction",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          if (value && typeof value === 'object') {
            return (
              <Link
                data-tip
                data-for="view"
                to={{ pathname: "/jvdetails" }}
                state={{ id: value }}
              >
                {value.id || "View"}
              </Link>
            );
          }
          return value || "Opening";
        },
      },
      setCellProps: () => ({ style: { textAlign: "center" } }),
    },
   
    {
      name: "entryType",
      label: "EntryType",
      options: {
        filter: false,
        sort: false,
         display: false,
        viewColumns: false,
      },
    },
    {
      name: "thid",
      label: "thid",
      options: {
        filter: false,
        sort: false,
         display: false,
        viewColumns: false,
      },
    },

    //{name: "warehouse",label:"Branch/Warehouse",options: {filter: false,sort: true,}},
   // {name: "price",label: "Unit Price",options: {filter: false,sort: true,sortOrder: 'asc',
    //   customBodyRender:(tableMeta)=>{
    //     return(<NumericFormat className="pr-3" displayType={'text'} value={tableMeta} decimalScale={2} fixedDecimalScale={true} disabled ={true} thousandSeparator={true} thousandsGroupStyle={thousandsdisplay}></NumericFormat>)
    //   },
    //   setCellProps: value => ({ style: { textAlign:'right'}}),
    // }},
    // {name: "amount",label: "Total Amount",options: {filter: false,sort: true,sortOrder: 'asc',
    //   customBodyRender:(tableMeta)=>{
    //     return(<NumericFormat className="pr-3" displayType={'text'} value={tableMeta} decimalScale={2} fixedDecimalScale={true} disabled ={true} thousandSeparator={true} thousandsGroupStyle={thousandsdisplay}></NumericFormat>)
    //   },
    //   setCellProps: value => ({ style: { textAlign:'right'}}),
    // }},
    // {name: "id",label:<span className="text-bold">Action</span>,options: {filter: false,sort: false,display:true,viewColumns:false,    
    //   customBodyRender:(value,tableMeta)=>{
    //     return (
    //       value.length!==0 ?<button className="hovbuttonColour btn btn-sm"
    //       onClick={() => submitRecord(tableMeta)}>  {loader===true? <><Spinner animation="border" size="sm" />&nbsp;{"Submitting"}</>:"Pass Entry"}
    //       </button>:<span className="text-red text-bold">No Values</span>
    //     );      
    //   },
    //   setCellProps: value => ({ style: { outerHeight:100}}),
    // }},
   ];


   const Bankoptions = {
    filterType: 'checkbox',
    selectableRows: "none",
    resizableColumns: true,

  }

  //  const onLedgerSelect=(value, values)=>{
  //   if (value !== undefined || value !== "") {
  //     let val = banks.filter((e) => e.ledgername === value).sort((a,b)=> a.createdAt<b.createdAt ? 1:-1);
  //     let val1 = banks.filter((e) =>  e.isopening!==1 && e.ledgername === value).sort((a,b)=> a.createdAt<b.createdAt ? 1:-1);
  //     setledgercode(val[0].ledgercode)

  //     let v1= val.filter(e=>e.entryType==="DEBIT");
  //     let v2= val.filter(e=>e.entryType==="CREDIT");

  //     let v3 = v2.map(e=>e.jvid!==null && e.jvid.creditname==="Settlement" ?e.jvamount:0)
  //     // console.log(getTotal(v3)*2)

  //     setdebtotal(parseFloat(getTotal(v1.map(e=>e.jvamount))+getTotal(v3)*2).toFixed(2))
  //    setcretotal(parseFloat(getTotal(v2.map(e=>e.jvamount))).toFixed(2))
      
  //     setselectedLed(val1)
  //     setSelectedledger(value)
  //     let opeamt,cloamt;
  //     val.map((e)=>e.isopening!==null  && e.isopening===1 ?(opeamt=e.amount) :(opeamt=0) )

  //     const closingbalance = [
  //       ...new Set(
  //         val.map((e) => {
  //           return e.closingbalance;
  //         })
  //       ),
  //     ];

  //     setopeningamt(opeamt)
  //     setcurrentamt(closingbalance!==null?closingbalance:0)

  //   }
  // }

  const onLedgerSelect = (value) => {
    if (!value || value === "") {
      setSelid(null);
      setSelectedledger('');
      setselectedLed([]);
      setopeningamt(0);
      setdebtotal(0);
      setcretotal(0);
      setcurrentamt(0);
    } else {
      setSelectedledger(value);
      const val = ledger.filter((e) => e.name === value);
      if (val.length > 0) {
        const selectedId = val[0].id;
        setSelid(selectedId);
        if (fsd && fed) {
          fetchLedgerData(selectedId, fsd, fed);
        }
      }
    }
  };

  const ledgers = [
    ...new Set(
      ledger.map((e) => {
        return (e.name || "").trim();
      })
    ),
  ];

  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
        <div className="card">
          <div className="card-header border-0 pb-0 d-flex justify-content-between align-items-center">
            <div>
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={() => navigate(-1)}
              >
                <i className="fas fa-arrow-left mr-1"></i> Back
              </button>
            </div>
            <ol className="breadcrumb float-sm-right mb-0 bg-transparent p-0">
              <li className="breadcrumb-item text-secondary">
                <Link to="/accounts">Home</Link>
              </li>
              <li className="breadcrumb-item active">Ledger</li>
            </ol>
          </div>
          <div className="form-row">
            <div className="card-body">
              <div>
                <div className="mb-5">
                  <Formik
                    initialValues={{ ledgersel: selectedledger || "", ledgers }}
                    enableReinitialize={true}
                  >
                    {({ values, setFieldValue }) => (
                      <Form autoComplete="off">
                        <div className="form-row col-md-12 mt-0 mb-3 align-items-center">
                          <fieldset className="form-group col-md-4 mt-0 mb-3">
                            <Autocomplete
                              id="aledgers"
                              className="grn-select"
                              name="aledersel"
                              options={ledgers}
                              getOptionLabel={(option) => option || ""}
                              value={selectedledger || values.ledgersel || null}
                              onChange={(e, value) => {
                                setFieldValue("ledgersel", value);
                                onLedgerSelect(value);
                              }}
                              renderInput={(params) => (
                                <FormikTextField
                                  {...params}
                                  className="form-control mb-3"
                                  type="text"
                                  name="ledgersel"
                                  label={
                                    selid === null ? (
                                      <span className="text-red">Select Ledger</span>
                                    ) : (
                                      <span className="black">Select Ledger</span>
                                    )
                                  }
                                  variant="standard"
                                  fullWidth
                                />
                              )}
                            />
                          </fieldset>
                          <fieldset className="form-group col-md-1 mt-0 mb-3 text-right">
                            <label>Opening : </label>
                          </fieldset>
                          <fieldset className="form-group col-md-1 mt-0 mb-3 text-left">
                            <label className="font-weight-bold">
                              <NumericFormat
                                displayType="text"
                                value={openingamt}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                thousandSeparator={true}
                                thousandsGroupStyle={thousandsdisplay}
                              />
                            </label>
                          </fieldset>
                          <fieldset className="form-group col-md-1 mt-0 mb-3 text-right">
                            <label>DebTot : </label>
                          </fieldset>
                          <fieldset className="form-group col-md-1 mt-0 mb-3 text-left">
                            <label className="font-weight-bold text-danger">
                              <NumericFormat
                                displayType="text"
                                value={debtotal}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                thousandSeparator={true}
                                thousandsGroupStyle={thousandsdisplay}
                              />
                            </label>
                          </fieldset>
                          <fieldset className="form-group col-md-1 mt-0 mb-3 text-right">
                            <label>CreTot : </label>
                          </fieldset>
                          <fieldset className="form-group col-md-1 mt-0 mb-3 text-left">
                            <label className="font-weight-bold text-success">
                              <NumericFormat
                                displayType="text"
                                value={cretotal}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                thousandSeparator={true}
                                thousandsGroupStyle={thousandsdisplay}
                              />
                            </label>
                          </fieldset>
                          <fieldset className="form-group col-md-1 mt-0 mb-3 text-right">
                            <label>Current : </label>
                          </fieldset>
                          <fieldset className="form-group col-md-1 mt-0 mb-3 text-left">
                            <label className="font-weight-bold">
                              <NumericFormat
                                displayType="text"
                                value={currentamt}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                thousandSeparator={true}
                                thousandsGroupStyle={thousandsdisplay}
                              />
                            </label>
                          </fieldset>

                          <div className="form-group col-md-1 text-left">
                            <label>
                              {fsd !== null ? <span>From Date</span> : <span className="text-red">From Date</span>}
                            </label>
                          </div>
                          <div className="form-group col-md-4 text-left">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <Grid justifyContent="space-around">
                                <DatePicker
                                  disableFuture
                                  showTodayButton
                                  showCancelButton
                                  variant="standard"
                                  id="date-picker-dialog-from"
                                  inputVariant="standard"
                                  minDate={transactionFrom ? dayjs(transactionFrom) : undefined}
                                  format="DD/MM/YYYY"
                                  value={fsd ? dayjs(fsd) : null}
                                  InputAdornmentProps={{ position: "start" }}
                                  onChange={handleFsdDateChange}
                                  renderInput={(params) => <TextField {...params} variant="standard" />}
                                  autoOk={true}
                                />
                              </Grid>
                            </LocalizationProvider>
                          </div>
                          <div className="form-group col-md-1 text-left">
                            <label>
                              {fed !== null ? <span>To Date</span> : <span className="text-red">To Date</span>}
                            </label>
                          </div>
                          <div className="form-group col-md-4 text-left">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <Grid justifyContent="space-around">
                                <DatePicker
                                  disableFuture
                                  showTodayButton
                                  showCancelButton
                                  variant="standard"
                                  id="date-picker-dialog-to"
                                  inputVariant="standard"
                                  maxDate={financialyearend ? dayjs(financialyearend) : undefined}
                                  format="DD/MM/YYYY"
                                  value={fed ? dayjs(fed) : null}
                                  InputAdornmentProps={{ position: "start" }}
                                  onChange={handleFsdDateChange1}
                                  renderInput={(params) => <TextField {...params} variant="standard" />}
                                  autoOk={true}
                                />
                              </Grid>
                            </LocalizationProvider>
                          </div>
                        </div>

                        {fsd !== null && fed !== null && selid !== null ? (
                          <div className="form-group col-md-1 text-left mb-3">
                            <button
                              type="button"
                              onClick={() => fetchLedgerData(selid, fsd, fed)}
                              className="btn btn-sm hovbuttonColour mr-2"
                            >
                              Search
                            </button>
                          </div>
                        ) : null}

                        {loading ? (
                          <div className="text-center py-4">{spin}</div>
                        ) : (
                          <ThemeProvider theme={theme}>
                            <MUIDataTable
                              className="table-sm px-3 text-sm"
                              title={
                                selectedledger
                                  ? `Ledger - ${selectedledger}`
                                  : ledgercode && typeof ledgercode === 'string' && ledgercode.trim().length > 0
                                  ? `Ledger - ${ledgercode}`
                                  : "Ledger"
                              }
                              id="dirstock"
                              data={selectedLed.map((oth) => {
                                return [
                                  oth.behav,
                                  oth.createdAt,
                                  oth.cndnid !== null
                                    ? oth.cndnid
                                    : oth.orderid !== null && oth.orderid.charAt(0) === 'S'
                                    ? oth.custominvid
                                    : oth.orderid !== null && oth.orderid.charAt(0) === 'P'
                                    ? oth.custompoid
                                    : oth.genadvanceadded != null
                                    ? "Advance Recd"
                                    : oth.orderid,
                                  oth.jvid !== null
                                    ? oth.jvid.debitname
                                    : oth.cjvid !== null
                                    ? oth.cjvid.name
                                    : "Opening",
                                  oth.jvid !== null
                                    ? oth.jvid.creditname
                                    : oth.cjvid !== null && oth.cjvid.jvinsertiontype === "SALARIES"
                                    ? oth.cjvid.cidthname
                                    : oth.cjvid !== null
                                    ? oth.cjvid.cname
                                    : "Opening",
                                  oth.jvid !== null
                                    ? oth.currentamt
                                    : oth.cjvid !== null
                                    ? oth.currentamt
                                    : oth.jvamount,
                                  oth.jvid !== null
                                    ? oth.jvamount
                                    : oth.cjvid !== null
                                    ? oth.jvamount
                                    : "Opening",
                                  oth.jvid !== null
                                    ? oth.jvamount
                                    : oth.cjvid !== null
                                    ? oth.jvamount
                                    : null,
                                  oth.genadvanceadded !== null ? oth.jvamount : null,
                                  oth.generaladvance === 1 && oth.genadvanceadded === null
                                    ? oth.jvamount
                                    : 0,
                                  oth.amount,
                                  oth.jvid !== null
                                    ? oth.jvid
                                    : oth.cjvid !== null
                                    ? oth.cjvid
                                    : "Opening",
                                  oth.entryType !== null ? oth.entryType : 0,
                                  oth.thid,
                                ];
                              })}
                              columns={Bankcolumns}
                              options={Bankoptions}
                            />
                          </ThemeProvider>
                        )}
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}         



 
